import { render, staticRenderFns } from "./ModalCookiePreferences.vue?vue&type=template&id=4e674f9d&scoped=true"
import script from "./ModalCookiePreferences.vue?vue&type=script&lang=js"
export * from "./ModalCookiePreferences.vue?vue&type=script&lang=js"
import style0 from "./ModalCookiePreferences.vue?vue&type=style&index=0&id=4e674f9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e674f9d",
  null
  
)

export default component.exports